<template>
    <base-section v-if="section" :section="section" :show-config-ui="showConfigUi" @edit-section="$emit('edit-section')"
                  @delete-section="$emit('delete-section')">
        <div>
            饼图栏目内容
        </div>
    </base-section>
</template>

<script>
    import BaseSection from './BaseSection'

    export default {
        name: "PieSectionPreview",
        components:{BaseSection},
        props: {
            name: String,
            showConfigUi: Boolean,
            refreshId: {
                type:Number,
                default: 0
            },
            pageId: Number,
            templateId: Number
        },
        data(){
            return {
                section: null
            }
        },
        watch:{
            refreshId(){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods:{
            async init(){
                this.section = {
                    name: this.name
                }
            }
        }
    }
</script>

<style scoped>

</style>
